import sliderAr from "./modules/sliderAr";
import tabs from "./modules/tabs";
import validate from "./modules/validate";
import modal from "./modules/modal";
import linearAnimations from "./modules/linearAnimations";

window.addEventListener("load", () => {

    tabs()
    sliderAr();
    validate('/[\u0600-\u06FF]/g');
    modal();
    linearAnimations();
});